import { addDays, applyDate, getStartOfDay } from '~shared/timeutils'

/**
 * When a hard start plays. A hard start is stored as a time of day plus
 * `startDatePlus`, a day offset from the show's start day; the stored date is
 * ignored. So moving the show moves every hard start with it, keeping each
 * one's time of day and day offset.
 *
 * DST: a time of day that doesn't exist on the target day (inside a
 * spring-forward gap) comes back shifted by the gap, as `applyDate` resolves it.
 *
 * @param startTime - the cue's stored `startTime`; only its time of day is used
 * @param startDatePlus - days after the show's start day
 * @param options.showStart - the show start the day offset counts from
 * @param options.timezone - IANA timezone the days are counted in, UTC when unset
 */
export function getHardStartTime(
  startTime: Date,
  startDatePlus: number,
  { showStart, timezone }: { showStart: Date; timezone?: string | null },
): Date {
  const tz = timezone ?? 'UTC'
  const day = addDays(getStartOfDay(showStart, { timezone: tz }), startDatePlus, { timezone: tz })
  return applyDate(startTime, day, { timezone: tz })
}
